"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PostMessageService = /** @class */ (function () {
    function PostMessageService(targets) {
        var _this = this;
        this.targets = targets;
        this.postMessageHandlers = [];
        window.addEventListener('message', function (event) {
            _this.handlePostMessage(event.data);
        }, false);
    }
    PostMessageService.prototype.sendPostMessage = function (target, message, targetOrigin) {
        if (targetOrigin === void 0) { targetOrigin = '*'; }
        var targetElement;
        if (typeof this.targets[target] === 'function') {
            targetElement = this.targets[target]();
        }
        else {
            targetElement = this.targets[target];
        }
        targetElement.postMessage(message, targetOrigin);
        console.debug('PostMessageService.sendPostMessage', target, message);
    };
    PostMessageService.prototype.sendWOPIPostMessage = function (target, msgId, values) {
        if (values === void 0) { values = {}; }
        var msg = {
            MessageId: msgId,
            SendTime: Date.now(),
            Values: values
        };
        this.sendPostMessage(target, JSON.stringify(msg));
    };
    PostMessageService.parsePostMessage = function (data) {
        var msgId = '';
        var args = {};
        var deprecated = false;
        try {
            var msg = JSON.parse(data);
            msgId = msg.MessageId;
            args = msg.Values;
            deprecated = !!msg.Values.Deprecated;
        }
        catch (exc) {
            msgId = data;
        }
        return { msgId: msgId, args: args, deprecated: deprecated };
    };
    PostMessageService.prototype.registerPostMessageHandler = function (callback) {
        this.postMessageHandlers.push(callback);
    };
    PostMessageService.prototype.unregisterPostMessageHandler = function (callback) {
        var handlerIndex = this.postMessageHandlers.findIndex(function (cb) { return cb === callback; });
        delete this.postMessageHandlers[handlerIndex];
    };
    PostMessageService.prototype.handlePostMessage = function (data) {
        var parsed = PostMessageService.parsePostMessage(data);
        if (typeof parsed === 'undefined' || parsed === null) {
            return;
        }
        this.postMessageHandlers.forEach(function (fn) {
            if (parsed.deprecated) {
                console.debug('PostMessageService.handlePostMessage', 'Ignoring deprecated post message', parsed.msgId);
                return;
            }
            fn({
                data: data,
                parsed: parsed
            });
        });
    };
    return PostMessageService;
}());
exports.default = PostMessageService;
